<div class="warning-banner">
  <rn-account-status-warning context="banner"/>
</div>
<router-outlet/>
